import React from 'react';
import { calculateNights, formatCurrencyValue } from '../utils/storage';
import { DollarSign } from 'lucide-react';

interface BudgetCalculatorProps {
  checkInDate: string;
  checkOutDate: string;
  rate: number;
}

export default function BudgetCalculator({ checkInDate, checkOutDate, rate }: BudgetCalculatorProps) {
  const nights = calculateNights(checkInDate, checkOutDate);
  const total = nights * rate;

  return (
    <div className="p-4 bg-indigo-50 border border-indigo-100 rounded-xl flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-indigo-100 text-indigo-700 rounded-lg">
          <DollarSign className="w-5 h-5" />
        </div>
        <div>
          <p className="text-[10px] font-bold text-indigo-900 uppercase">Estimativa de Orçamento</p>
          <p className="text-xs text-indigo-700">{nights} noites x {formatCurrencyValue(rate)}/diária</p>
        </div>
      </div>
      <div className="text-right">
        <p className="text-sm font-extrabold text-indigo-950">{formatCurrencyValue(total)}</p>
      </div>
    </div>
  );
}
